import { Typography } from '@mui/material'

const HelpText = () => (
  <div className='p-5'>
    <Typography variant='h4'>Credit usage</Typography>
    <p>This page lists credit-consuming activity for the selected client, such as issuing, updating and notifying passes. Use the date range and table controls to find a particular event or export the data.</p>
    <Typography variant='h5'>Understanding costs</Typography>
    <p>The row describes the action, template, number of passes and credits used. Costs are quoted before any action that consumes credits is confirmed.</p>
    <p>See the <a href='https://www.smartix.uk/pricing/' target='_blank' rel='noreferrer'>pricing page</a> for the credit cost breakdown.</p>
  </div>
)

export default HelpText
